import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface DialogData {
  jobID: string;
}

@Component({
  selector: 'app-job-progress',
  templateUrl: './job-progress.component.html',
  styleUrls: ['./job-progress.component.scss']
})
export class JobProgressDialogComponent {
  
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData) { }

}
